import "./ChangePassword.css";

import CustomInput from "../../CustomInput/CustomInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PasswordValidator from "../../PasswordValidator/PasswordValidator";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { updatePassword } from "../../../api/auth";
import { useState } from "react";

interface ChangePasswordProps {
  errors: any;
  setErrors: any;
  setProfileSection: (section: any) => void;
}

const ChangePassword = ({ errors, setErrors, setProfileSection }: ChangePasswordProps) => {
  const [confirmNewPassword, setConfirmNewPassword] = useState<string>("");
  const [passwordChange, setPasswordChange] = useState<boolean>(false);
  const [newPassword, setNewPassword] = useState<string>("");
  const [updatePasswordSuccess, setUpdatePasswordSuccess] = useState<boolean>(false);

  const onChangePasswordHeaderClicked = () => {
    setPasswordChange(false);
    setNewPassword("");
    setConfirmNewPassword("");
  };

  const onSavePasswordClicked = () => {
    setErrors([]);
    if (!newPassword?.trim()) {
      document.getElementById("password-input")!.style.border = "1px solid red";
      setErrors((errors: any) => [...errors, "Please enter a password"]);
      return false;
    } else {
      document.getElementById("password-input")!.style.border = "1px solid #d7d7d7";
    }

    if (!confirmNewPassword?.trim()) {
      document.getElementById("confirm-password-input")!.style.border = "1px solid red";
      setErrors((errors: any) => [...errors, "Please confirm your password"]);
      return false;
    } else {
      document.getElementById("confirm-password-input")!.style.border = "1px solid #d7d7d7";
    }

    if (newPassword?.trim() !== confirmNewPassword?.trim()) {
      setErrors((errors: any) => [...errors, "Passwords must match"]);
      return false;
    }

    if (newPassword && newPassword?.trim().length < 8) {
      setErrors((errors: any) => [...errors, "Password must be 8 characters or more"]);
      return false;
    }

    if (!/[A-Z]/.test(newPassword!)) {
      setErrors((errors: any) => [
        ...errors,
        "Password must contain at least one uppercase character",
      ]);
      return false;
    }

    if (!/[a-z]/.test(newPassword!)) {
      setErrors((errors: any) => [
        ...errors,
        "Password must contain at least one lowercase character",
      ]);
      return false;
    }

    if (!/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(newPassword!)) {
      setErrors((errors: any) => [
        ...errors,
        "Password must include at least one special character",
      ]);
      return false;
    }
    if (!/\d/.test(newPassword!)) {
      setErrors((errors: any) => [...errors, "Password must include at least one number"]);
      return false;
    }
    if (newPassword && confirmNewPassword) {
      updatePassword(newPassword, confirmNewPassword).then((response: any) => {
        if (response.status) {
          setNewPassword("");
          setConfirmNewPassword("");
          setUpdatePasswordSuccess(true);
          setPasswordChange(false);
          toast.success("Password updated", {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.error(
            response.errors.password[0] ? response.errors.password[0] : "Error updating password",
            {
              position: toast.POSITION.TOP_RIGHT,
            }
          );
        }
      });
    }
  };
  return (
    <div className="change-password-container">
      {/* Change password */}
      {window.innerWidth <= 480 ? (
        <div className="profile-details-header" onClick={() => setProfileSection(null)}>
          <FontAwesomeIcon icon={faArrowLeft} size="1x" color="#18283c" />
          <p>Change your password</p>
        </div>
      ) : null}
      <div className="edit-profile-container">
        <div className="edit-profile-input-container">
          <CustomInput
            id="password-input"
            label="NEW PASSWORD"
            type="password"
            placeholder="New Password"
            value={newPassword}
            setValue={setNewPassword}
          />
          <CustomInput
            id="confirm-password-input"
            label="CONFIRM NEW PASSWORD"
            type="password"
            placeholder="Confirm New Password"
            value={confirmNewPassword}
            setValue={setConfirmNewPassword}
            containerStyle={{ marginTop: 20, marginBottom: 20 }}
          />
          {errors.length > 0 && <p className="error-text">* {errors[0]}</p>}
          <PasswordValidator password={newPassword} newPassword={confirmNewPassword} />
        </div>
        <div className="password-save-button" onClick={() => onSavePasswordClicked()}>
          <p>Save</p>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
